import React from 'react';

import {
  FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQuery, FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQueryVariables, FlowDownstreamOwnerIdsQuery, FlowDownstreamOwnerIdsQueryVariables, OwnerIdFragment,
  FlowDownstreamOwnerIdsFilteredByFlowOutputFieldDocument,
  FlowDownstreamOwnerIdsDocument
} from '../../../../../gen-src/queries';
import {
  ComposeEmailPaneButton,
  DataCatalogApolloClient,
  getAllFromSliceable,
  GraphQLSliceable,
  HorizontalFlexContainer,
  MultiSelectionProvider,
  PaneTitle,
  Sliceable,
  VerticalFlexContainer
} from '../../../data-catalog-shared';
import { OwnersGridSortProvider } from '../sorting/sortProviders/OwnersGridSortProvider';
import { MultiSelectionControls } from '../widgets/MultiSelectionControls';
import { FlowDownstreamOwnersQueryGrid } from './FlowDownstreamOwnersQueryGrid';

export interface FlowDownstreamOwnersPaneProps {
  readonly title: string;
  readonly flowVizportalUrlId: string;
  readonly filteredFlowOutputFieldId: string | null;
  readonly rowCount: number | null;
  readonly flowLuid: string;
}

export class FlowDownstreamOwnersPane extends React.Component<FlowDownstreamOwnersPaneProps> {

  public override render(): JSX.Element {
    return (
      <MultiSelectionProvider selectionId={this.props.flowVizportalUrlId}>
        {({ selectedKeys, setSelectedKeys, updateSelectionForKey }) =>
          <VerticalFlexContainer fillFlexParent={true}>
            <PaneTitle>
              <HorizontalFlexContainer>
                {this.props.title}
                {this.props.rowCount != null && this.props.rowCount > 0 ?
                  <>
                    <MultiSelectionControls
                      selectedKeys={selectedKeys}
                      setSelectedKeys={setSelectedKeys}
                      updateSelectionForKey={updateSelectionForKey}
                      fetchAllKeys={this.fetchAllOwnerKeys}
                    />
                    <ComposeEmailPaneButton
                      selectedUserIds={selectedKeys}
                      contentType='flow'
                      contentId={this.props.flowVizportalUrlId}
                      contentLuid={this.props.flowLuid}
                    />
                  </>
                  : null
                }
              </HorizontalFlexContainer>
            </PaneTitle>
            <OwnersGridSortProvider>
              {({ orderBy, updateSortOrder }) =>
                <FlowDownstreamOwnersQueryGrid
                  flowVizportalUrlId={this.props.flowVizportalUrlId}
                  selectedKeys={selectedKeys}
                  updateSelectionForKey={updateSelectionForKey}
                  filteredFlowOutputFieldId={this.props.filteredFlowOutputFieldId}
                  rowCount={this.props.rowCount}
                  orderBy={orderBy}
                  updateSortOrder={updateSortOrder}
                />
              }
            </OwnersGridSortProvider>
          </VerticalFlexContainer>
        }
      </MultiSelectionProvider>
    );
  }

  private readonly fetchAllOwnerKeys = async (client: DataCatalogApolloClient): Promise<ReadonlyArray<string>> => {
    const sliceable = this.createOwnerIdsSliceable(client);
    const items = await getAllFromSliceable(sliceable);
    return items.map(item => item.vizportalId);
  }

  private createOwnerIdsSliceable(client: DataCatalogApolloClient): Sliceable<OwnerIdFragment> {
    if (this.props.filteredFlowOutputFieldId) {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQueryVariables,
        FlowDownstreamOwnerIdsFilteredByFlowOutputFieldQuery
      >({
        queryGql: FlowDownstreamOwnerIdsFilteredByFlowOutputFieldDocument,
        selectConnectionListResult: (resultData) => {
          const flow = resultData.flows && resultData.flows[0];
          const outputField = flow && flow.outputFields && flow.outputFields[0];
          return outputField.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, {
        flowVizportalUrlId: this.props.flowVizportalUrlId,
        selectedFlowOutputFieldId: this.props.filteredFlowOutputFieldId,
      }, client);
    } else {
      return new GraphQLSliceable<
        OwnerIdFragment,
        OwnerIdFragment,
        FlowDownstreamOwnerIdsQueryVariables,
        FlowDownstreamOwnerIdsQuery
      >({
        queryGql: FlowDownstreamOwnerIdsDocument,
        selectConnectionListResult: (resultData) => {
          const flow = resultData.flows && resultData.flows[0];
          return flow.downstreamOwnersConnection;
        },
        mapResultNode: (node) => node,
      }, { flowVizportalUrlId: this.props.flowVizportalUrlId }, client);
    }
  }

}

